import { DeepgramGenerateSubtitlesOptions } from '@core/types';
import { Heading, Input, Select } from '@core/ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const DeepgramOptionsMolecule = ({
    options,
    updateOptions
}: {
    options: DeepgramGenerateSubtitlesOptions;
    updateOptions: (options: DeepgramGenerateSubtitlesOptions) => void;
}) => {
    const { t } = useTranslation();
    const [englishOnly, setEnglishOnly] = useState(false);
    const [hasMultiLanguage, setHasMultiLanguage] = useState(true);

    useEffect(() => {
        if (options) {
            setEnglishOnly(options.model === 'flux-general-en' || options.model === 'nova-3-medical');
            if ((options.model === 'flux-general-en' || options.model === 'nova-3-medical') && options.language !== 'en') {
                updateOptions({ ...options, language: 'en' });
            }
            setHasMultiLanguage(options.model !== 'whisper');
            if (options.model === 'whisper' && options.language === 'multi') {
                updateOptions({ ...options, language: 'en' });
            }
        }
    }, [options]);

    return (
        <>
            <Heading variant="h3" classNames="mb-4">
                {t('EditSubtitles.GenerateSubtitlesOptions.DeepgramSettings')}
            </Heading>
            <div className="mb-6 pl-10">
                <input
                    id="deepgram.enabled"
                    type="checkbox"
                    role="switch"
                    checked={options.isEnabled}
                    onChange={(e) => updateOptions({ ...options, isEnabled: e.target.checked })}
                    className="w-2em h-1em appearance-none bg-inherit bg-switch bg-[center_left] focus-visible:not-checked:bg-switch-focus checked:bg-primary checked:bg-switch-checked checked:bg-[center_right] bg-no-repeat border-2 border-gray-500 focus-visible:border-primary checked:border-primary rounded-full float-left mt-0.25em -ml-10 outline-hidden focus-visible:shadow-[0_0_0_.25rem_hsl(var(--c-primary)/.3)] motion-safe:transition-[background-position] duration-150 ease-in-out"
                />
                <label htmlFor="deepgram.enabled" className="inline-block">
                    {t('LiveTranscribe.Label.DeepgramEnabled')}
                </label>
            </div>
            {options.isEnabled && (
                <>
                    <Input
                        classNames="mb-6"
                        label={t('LiveTranscribe.Label.TrackId')}
                        value={options.trackId || ''}
                        onChange={(e) => updateOptions({ ...options, trackId: e.target.value })}
                    />
                    <Select
                        name="model"
                        classNames="mb-6"
                        label={t('LiveTranscribe.Label.DeepgramModel')}
                        value={options.model}
                        onChange={(e) => updateOptions({ ...options, model: e.target.value })}
                    >
                        <option key="nova-3" value="nova-3">
                            nova-3
                        </option>
                        <option key="nova-3-general" value="nova-3-general">
                            nova-3-general
                        </option>
                        <option key="nova-3-medical" value="nova-3-medical">
                            nova-3-medical
                        </option>
                        <option key="flux-general-en" value="flux-general-en">
                            flux-general-en
                        </option>
                        <option key="whisper" value="whisper">
                            whisper
                        </option>
                    </Select>
                    <Select
                        name="model"
                        label={t('LiveTranscribe.Label.DeepgramLanguage')}
                        value={options.language}
                        onChange={(e) => updateOptions({ ...options, language: e.target.value })}
                    >
                        {!englishOnly && hasMultiLanguage && (
                            <option key="multi" value="multi">
                                {t('LiveTranscribe.Option.DeepgramLanguage.Multi')}
                            </option>
                        )}
                        <option key="en" value="en">
                            {t('LiveTranscribe.Option.DeepgramLanguage.English')}
                        </option>
                        {!englishOnly && (
                            <>
                                <option key="nl" value="nl">
                                    {t('LiveTranscribe.Option.DeepgramLanguage.Dutch')}
                                </option>
                                <option key="fr" value="fr">
                                    {t('LiveTranscribe.Option.DeepgramLanguage.French')}
                                </option>
                                <option key="de" value="de">
                                    {t('LiveTranscribe.Option.DeepgramLanguage.German')}
                                </option>
                                {/* More language options can be added here: https://developers.deepgram.com/docs/models-languages-overview */}
                            </>
                        )}
                    </Select>
                </>
            )}
        </>
    );
};
